export enum Modiwl {
    Amserlennu = 1,
    Archeb,
    Cerbyd,
    Cwsmer,
    Cyflenwr,
    Diogelwch,
    DogfenDyroddiad,
    Gwaith,
    Gwirio,
    Gyrrwr,
    Opsiwn,
    Stoc,
    Storfa,
    Tracio,
    Cartref,
    Adroddiad,
    Data
}